import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchAll({ toolCycleTimeParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: 'tool/GetToolAvgCycleTime',
      params: toolCycleTimeParams,
    });
    const toolCycleTimeData = data;
    yield put(Actions.setAll({ toolCycleTimeData }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* updateToolCycleTime({ toolData, toolCycleTimeParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.put, {
      route: `tool/UpdateToolCycleTime`,
      params: toolData,
    });
    yield put(Actions.fetchAll({ toolCycleTimeParams }));
    notification('success', CONSTANT_VARIABLES.AVG_CYCLE_TIME_UPDATED, '');
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}
// ------- export tool cycle time
function* exportToolCycleTime() {
  try {
    yield put(Actions.setToolCycleTimeExportLoader({ toolCycleTimeExportByLoader: true }));
    const { data } = yield call(api.get, {
      route: 'tool/ExportToolAvgCycleTime',
    });
    const toolCycleTimeExportData = data;
    yield put(Actions.setToolCycleTimeExportData({ toolCycleTimeExportData }));
    yield put(Actions.setToolCycleTimeExportLoader({ toolCycleTimeExportByLoader: false }));
    notification('success', CONSTANT_VARIABLES.FILE_DOWNLOADED_SUCCESSFULLY, '');
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_ALL, fetchAll),
    takeLatest(ActionTypes.UPDATE_TOOL_CYCLE_TIME, updateToolCycleTime),
    takeLatest(ActionTypes.TOOL_CYCLE_TIME_EXPORT, exportToolCycleTime),
  ]);
}
